import {ContentListService, materialUpload} from "../../basic/path"
import RequestModel from "../../basic/requestConfig";
export default {
    getWeChatMiniProgramName(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: materialUpload.getWeChatMiniProgramName,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },
    getWechatOATemplateList(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: materialUpload.getWechatOATemplateList,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    uploadMaterial(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: materialUpload.uploadMaterial,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },
    getMaterialList(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: materialUpload.getMaterialList,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },
    getCategoryList(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: materialUpload.getCategoryList,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },
    delSingleMaterial(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: materialUpload.delSingleMaterial,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers:{
                        'Content-Type':"application/json;charset=UTF-8"
                    }
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },

    updUploadFiles(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: materialUpload.updUploadFiles,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers:{
                        'Content-Type':"application/json;charset=UTF-8"
                    }
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },

    submit(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: materialUpload.submit,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers:{
                        'Content-Type':"application/json;charset=UTF-8"
                    }
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },

    getTagsList(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: materialUpload.getTagsList,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },
    uploadAvatar(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: materialUpload.uploadAvatar,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },uploadAttachments(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: materialUpload.uploadAttachments,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },
    addLevel(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: materialUpload.addLevel,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers:{
                        'Content-Type':"application/json;charset=UTF-8"
                    }
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },
    addTag(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: materialUpload.addTag,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers:{
                        'Content-Type':"application/json;charset=UTF-8"
                    }
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },
    getTagMaxSort(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: materialUpload.getTagMaxSort,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },
    
}
